import axios from '../utils/index'
import axios1 from 'axios'

// 书籍阅读权限接口
export function checkIfPermittedToRead(params) {
  return axios.post('/portal/book/checkIfPermittedToRead', params)
}

// 前台书籍价格获取接口
export function getBookPrice(params) {
  return axios.post('/portal/book/getBookPrice', params)
}

// 前台购买书籍
export function purchaseBooks(data) {
  return axios1({
    method: 'post',
    url: '/portal/sybpay/purchaseBooks',
    data: data,
    headers: {'Content-Type': 'application/json'}
  });
}

// 查询支付订单状态
export function queryPayResult(params) {
  return axios.post('/portal/sybpay/queryPayResult', params)
}

// 子库购买
export function purchaseSublibrary(params) {
  return axios.post('/portal/sybpay/purchaseSublibrary', params)
}
